import { render, staticRenderFns } from "./CommentBody.vue?vue&type=template&id=c77b1d5c"
import script from "./CommentBody.vue?vue&type=script&lang=js"
export * from "./CommentBody.vue?vue&type=script&lang=js"
import style0 from "./CommentBody.vue?vue&type=style&index=0&id=c77b1d5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports